import { ResultsRow } from '@data/types';
import classNames from 'classnames';
import React from 'react';

interface Props extends ResultsRow {}

const ResultRow: React.FC<Props> = ({ score, label, iconColour }) => {
  return (
    <tr>
      <td className="pr-2 pt-2">
        <i
          className={classNames(
            'px-2  rounded-tr-lg rounded-bl-lg',
            iconColour
          )}
        ></i>
      </td>
      <td className="text-left align-middle pr-2 pt-2 leading-snug">{label}</td>
      <td className="text-right pr-2 pt-2 leading-snug">{score}</td>
    </tr>
  );
};

export default ResultRow;
